<template>
	<div>
<!--Page de login - Authentification--------------------------------------------------------------------------------------------------------------------------------------------------------->						

	<Authentification/>		

<!--Page d'accueil--------------------------------------------------------------------------------------------------------------------------------------------------------->						

		<v-flex	xs12 md12 v-if="$store.state.authenticated">
			<v-tabs 
				v-model="$store.state.active" 
				color="cyan" 
				dark 
				slider-color="yellow" 
				center-active
				next-icon="mdi-arrow-right-bold-box-outline"
				prev-icon="mdi-arrow-left-bold-box-outline"
				show-arrows
			>

<!--Page gestion des onduleurs--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="1" ripple @click="getInvertersList">
					<h3>Onduleurs</h3>
				</v-tab>
				<v-tab-item key="1">
					<GestionOnduleurs/>
				</v-tab-item>

<!--Page gestion des optimiseurs--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="2" ripple @click="getOptimizersList">
					<h3>Optimiseurs</h3>
				</v-tab>
				<v-tab-item key="2">
					<GestionOptimiseurs/>
				</v-tab-item>

<!--Page gestion des modules--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="3" ripple @click="getModulesList">
					<h3>Modules PV</h3>
				</v-tab>
				<v-tab-item key="3">
					<GestionModules/>
				</v-tab-item>

<!--Page gestion des batteries--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="4" ripple @click="getBatteriesList">
					<h3>Batteries</h3>
				</v-tab>
				<v-tab-item key="4">
					<GestionBatteries/>
				</v-tab-item>

<!--Page gestion des câbles--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="5" ripple @click="getCablesList">
					<h3>Câbles</h3>
				</v-tab>
				<v-tab-item key="5">
					<GestionCables/>
				</v-tab-item>

<!--Page gestion des compteurs--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="6" ripple @click="getMetersList">
					<h3>Compteurs</h3>
				</v-tab>
				<v-tab-item key="6">
					<GestionCompteurs/>
				</v-tab-item>

<!--Page gestion des SMAStorage--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="7" ripple @click="getSmaStorageList">
					<h3>SMA Storage</h3>
				</v-tab>
				<v-tab-item key="7">
					<GestionSmaStorage/>
				</v-tab-item>

<!--Page gestion des utilisateurs--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="8" ripple  v-if="$store.state.authenticatedAdmin" @click="getUsersList">
					<h3>Utilisateurs</h3>
				</v-tab>
				<v-tab-item key="8">
					<GestionUtilisateurs/>
				</v-tab-item>

			</v-tabs>
		</v-flex>
	</div>

</template>

<!--Scripts--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<script>
	import axios from 'axios';
	import Authentification from './Authentification.vue';
	import GestionOnduleurs from './GestionOnduleurs.vue';
	import GestionOptimiseurs from './GestionOptimiseurs.vue';
	import GestionModules from './GestionModules.vue';
	import GestionBatteries from './GestionBatteries.vue';
	import GestionCables from './GestionCables.vue';
	import GestionCompteurs from './GestionCompteurs.vue';
	import GestionSmaStorage from './GestionSmaStorage.vue';
	import GestionUtilisateurs from './GestionUtilisateurs.vue';
	import createListBoolMixins from './mixins/createListBoolMixins.js';

	export default {
		name: "Formulaire",
		mixins: [
			createListBoolMixins,
		],
		components: {
			Authentification,
			GestionOnduleurs,
			GestionOptimiseurs,
			GestionModules,
			GestionBatteries,
			GestionCables,
			GestionCompteurs,
			GestionSmaStorage,
			GestionUtilisateurs,
		},
		data: function () {
			return {
				axios_error: "",
                attachment_oversize_text: "",
			};
		},
		created() {
			axios.interceptors.request.use((config) => {
				this.setLoading(true);
				return config;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
			axios.interceptors.response.use((response) => {
				this.setLoading(false);
				return response;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
		},
		mounted() {
			this.exportDatabase();
			this.getInvertersList();
			this.getOptimizersList();
			this.getModulesList();
			this.getBatteriesList();
			this.getCablesList();
			this.getMetersList();
			this.getInvertersList();
			this.getSmaStorageList();
			this.getUsersList();
		},
		methods: {
			exportDatabase: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/exportDatabase.php";
				axios.get(link).then(response => (
					this.$store.state.databaseExported = response.data,
					this.createInvertersListBool()
				));
			},
			getInvertersList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadInvertersList.php";
				axios.get(link).then(response => (
					this.$store.state.invertersList = response.data,
					this.createInvertersListBool()
				));
			},
			getOptimizersList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadOptimizersList.php";
				axios.get(link).then(response => (
					this.$store.state.optimizersList = response.data,
					this.createOptimizersListBool()
				));
			},
			getModulesList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadModulesList.php";
				axios.get(link).then(response => (
					this.$store.state.modulesList = response.data,
					this.createModulesListBool()
				));
			},
			getBatteriesList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadBatteriesList.php";
				axios.get(link).then(response => (
					this.$store.state.batteriesList = response.data,
					this.createBatteriesListBool()
				));
			},
			getCablesList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadCablesList.php";
				axios.get(link).then(response => (
					this.$store.state.cablesList = response.data,
					this.createCablesListBool()
				));
			},
			getMetersList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadMetersList.php";
				axios.get(link).then(response => (
					this.$store.state.metersList = response.data,
					this.createMetersListBool()
				));
			},
			getSmaStorageList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadSmaStorageList.php";
				axios.get(link).then(response => (
					this.$store.state.smaStorageList = response.data,
					this.createSmaStorageListBool()
				));
			},
			getUsersList: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadUsersList.php";
				axios.get(link).then(response => (
					this.$store.state.usersList = response.data,
					this.createUsersListBool()
				));
			},
			getSmaStorageList_new: function () {
				var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadSmaStorageList.php";
				this.$store.state.axios_error = "";
                var data = this.$store.state.smaStorageListBool;
				axios.post(link, data, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(response => {
					this.$store.state.smaStorageResponse = response;
					this.$store.state.api_status = response.data.api_status;
					this.$store.state.axios_error = "";
                    if(response.data.smaStorageListLoaded) {
                        this.createSmaStorageListBool();
                    }
                }).catch((error) => {
                    this.$store.state.axios_error = error;
                });
			},
			setLoading(temp_state) {
				if (temp_state) {
					this.$store.state.is_loading = true;
				}
				else {
					this.$store.state.is_loading = false;
				}
			},
		},
	}

</script>

<style>
	h2 {
		margin: 10px;
	}
	.progress {
		margin-top: 1px;
	}
	.cardWrapper {
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
	.table-bordered {
		border-collapse: collapse;
	}
	.table-bordered {
		border: 1px solid black;
	}
	.th-bordered {
		border: 1px solid black;
	}
	.td-bordered {
		border: 1px solid black;
	}
	tr:hover {background-color: #f5f5f5;}
</style>
